import { createFileRoute } from "@tanstack/react-router";
import { TermEditPage } from "@client/components/settings/semantic-governance/term-edit-page";

export const Route = createFileRoute(
  "/_app/tenant-settings/semantic-governance/terms/edit/$id",
)({
  component: TermEditRoute,
});

function TermEditRoute() {
  const { id } = Route.useParams();
  return <TermEditPage id={id} />;
}
